import {
  Button,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  useDebounceCallback,
} from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { XIcon } from "lucide-react";
import { useEffect, useState } from "react";
export function ProductsFilter() {
  const nav = useNavigate();
  const search = useSearch({ strict: false }) as {
    limit?: number;
    offset?: number;
    sort?: Array<{ field: string; dir: "asc" | "desc" }> | string;
    search?: string;
    status?: "draft" | "active" | "archived";
  };

  const [searchValue, setSearchValue] = useState<string>(search.search ?? "");

  useEffect(() => {
    setSearchValue(search.search ?? "");
  }, [search.search]);

  const debounced = useDebounceCallback((val: string) => {
    nav({
      search: {
        ...search,
        offset: 0,
        search: val || undefined,
      },
    });
  }, 400);

  const handleStatusChange = (value: string) => {
    nav({
      search: {
        ...search,
        status: value === "all" ? undefined : (value as typeof search.status),
        offset: 0,
      },
    });
  };

  const hasFilter = !!(search.search || search.status);

  return (
    <div
      className="mb-4 flex flex-wrap items-center gap-4 px-2"
      data-tourid="products-filter"
    >
      <Input
        placeholder="ຄົ້ນຫາຕາມຊື່, SKU ຫຼື slug..."
        defaultValue={searchValue}
        onChange={(e) => {
          const v = e.target.value;
          debounced(v);
        }}
        className="h-8 sm:max-w-2xs"
      />
      <Select value={search.status ?? "all"} onValueChange={handleStatusChange}>
        <SelectTrigger className="h-8 w-[160px]">
          <SelectValue placeholder="ສະຖານະ" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">ທັງໝົດ</SelectItem>
          <SelectItem value="draft">ແບບຮ່າງ</SelectItem>
          <SelectItem value="active">ເປີດໃຊ້ງານ</SelectItem>
          <SelectItem value="archived">ເກັບຖາວອນ</SelectItem>
        </SelectContent>
      </Select>
      {hasFilter && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() =>
            nav({
              search: {
                ...search,
                offset: 0,
                search: undefined,
                status: undefined,
              },
            })
          }
        >
          <XIcon className="h-4 w-4" /> ລ້າງຕົວກອງ
        </Button>
      )}
    </div>
  );
}
